import { Breadcrumb } from '@components/common/breadcrumb';
import { Item } from '../item';
import { Page } from '@model/common';
import { useI18NextContext } from '@components/hooks';
import { HelpCategory, HelpArticle } from '@model/iceberg/help-centre';
import { getPathFromName } from '@util/path';
import { TestId } from '@components/test-ids';

export interface HelpCentreBreadcrumbProps {
  category?: HelpCategory;
  article?: HelpArticle;
}

export const HelpCentreBreadcrumb = ({ category, article }: HelpCentreBreadcrumbProps) => {
  const t = useI18NextContext();

  const items: Array<Item> = [{ as: Page.HELP_CENTRE, href: Page.HELP_CENTRE, display: t('common__label--help') }];
  if (category) {
    const categoryTitle = category.title;
    const categoryPath = getPathFromName(categoryTitle);
    items.push({
      as: `${Page.HELP_CENTRE}/${categoryPath}`,
      href: `${Page.HELP_CENTRE}/[category]`,
      display: categoryTitle
    });
    if (article) {
      const articleTitle = article.title;
      const articlePath = getPathFromName(articleTitle);
      items.push({
        as: `${Page.HELP_CENTRE}/${categoryPath}/${articlePath}`,
        href: `${Page.HELP_CENTRE}/[category]/[article]`,
        display: articleTitle
      });
    }
  }

  return <Breadcrumb items={items} testId={TestId.helpCentre.breadcrumb.main} />;
};
